module.exports = __webpack_public_path__ + "ff1ba99bd7f041dcf2563595a295bea5.svg";